// extracted by mini-css-extract-plugin
export default {"header":"Style_header__6lN1I","headerTitle":"Style_headerTitle__5g0Vh","menuOpener":"Style_menuOpener__vKVBN"};